import { List, ListItem, ListItemText, ListSubheader } from '@mui/material';
import { Role, roleMap } from 'utils/userPermissions';
import { useAppSelector } from '../../app/hooks';
import { useUsersWithoutSelfOrSuperUser } from './api/getUsersWithoutSelfOrSuperUser';

interface Props {
  handleUserClicked: (userId: number) => void;
  selectedUser: number | null;
}
const UserList = ({ selectedUser, handleUserClicked }: Props) => {
  const { user: loggedinUser } = useAppSelector((state) => state.auth);
  const { data: users } = useUsersWithoutSelfOrSuperUser({
    currentUserId: loggedinUser?.id || -1,
  });

  const frozenText = (frozen: boolean) => (frozen ? `(Frozen)` : '');

  return (
    <List
      subheader={
        <ListSubheader component='div' id='nested-list-subheader' disableSticky>
          Users
        </ListSubheader>
      }
    >
      {users?.map((user) => (
        <ListItem
          selected={selectedUser !== null && user.id === selectedUser}
          button
          key={user.id}
          onClick={() => handleUserClicked(user.id)}
        >
          <ListItemText
            primary={user.name}
            secondary={`${user.email} ${
              roleMap[user.role as Role]
            } ${frozenText(user.frozen || false)}`}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default UserList;
